/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/pi.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the value of pi.
 *
 * @example
 * pi()
 */
const definition: PromqlFunctionDefinition = {
  type: 'scalar',
  name: 'pi',
  signatures: [
    {
      params: [],
      variadic: false,
      returnType: 'scalar',
    },
  ],
  snapshotOnly: false,
};

export default definition;
